<template>
<!--  <div class="container">-->
<!--    <ProductsMenu @productsSelect="productsSelect"/>-->
<!--    <div style="margin-bottom: 50px">-->
<!--      <div class="service">-->
<!--        <div class="title" data-aos="fade-up">人类遗传资源管理行政审批服务</div>-->
<!--        <img :src="require('@/assets/img/products/service/serviceContent.png')" data-aos="zoom-in">-->
<!--        <div class="text" data-aos="fade-up">-->
<!--          人类遗传资源包括人类遗传资源材料和人类遗传资源信息。人类遗传资源材料是指含有人体基因组、基因等遗传物页的器官、组织、细胞等遗传材料，人类遗传资源信息是指利用人类遗传资源材料产生的数据等信息资料。类遗传资源管理行政审批服务包括中国人类遗传资源采集审批、保藏审批、国际合作科学研究审批、遗传资源材料出境审批、国际合作临床试验备案、信息对外提供或开放使用备案。人类遗传资源采集活动，包括重要遗传家系(患病家系或具有遗传性特殊体质或生理特征成员五人以上，涉及三代)、特定地区人类遗传资源和国务院科学技术行政部门规定种类(罕见病、具有显著性差异的特殊体质或生理特征的人群)、数量(累积500人以上)-->
<!--        </div>-->
<!--        <div class="text" data-aos="fade-up">-->
<!--          国际合作科学研究，是指与外国组织及外国组织、个人设立或者实际控制的机构(称外方单位)合作进行的科学研究活动; <br>信息对外提供或开放使用，指的是将人类溃传资源(以下简称人遗)向外国组织、个人及其设立或者实际控制的村勾提供或开放使用。-->
<!--        </div>-->
<!--        <div class="text" data-aos="fade-up">-->
<!--          人类遗传资源采集、保藏、利用、对外提供过程中应当遵守《中华人民共和国人类遗传资源管理条例》 (国令第717号)等的相关规定。项目须在获得中国人类遗传资源管理办公室批准或备案后方可启动开展。-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="approval">-->
<!--        <div>-->
<!--          <div class="title" data-aos="fade-up">审批流程</div>-->
<!--          <div class="list">-->
<!--            <div class="content" v-for="(item,index) in approvalList" data-aos="zoom-in">-->
<!--              <div class="left">-->
<!--                <div class="ellipse">-->
<!--                  STEP-->
<!--                  <br>-->
<!--                  {{index+1}}-->
<!--                </div>-->
<!--                <div v-html="item" class="text"></div>-->
<!--              </div>-->
<!--              <div class="right">-->
<!--                <i class="el-icon-arrow-right" v-if="index<3"></i>-->
<!--                <i class="el-icon-arrow-left" v-else-if="index>3"></i>-->
<!--                <i class="el-icon-arrow-down" v-else></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";
export default {
  name: "examine",
  components:{ProductsMenu},
  data(){
    return{
      approvalList:[
        '网上申请',
        '网上预受理',
        '纸质申请<br>材料提交',
        '纸质材料<br>审查与受理',
        '文书送达',
        '结果公布',
        '审批决定',
        '技术评审'
      ],
    }
  },
  methods:{
    productsSelect(src){
      this.$emit('productsSelect',src)
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  padding-left: 20%;
  box-sizing: border-box;
  position: relative;
}
.introduction{
  .title{
    width: 417px;
    height: 58px;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;
    margin: 213px auto 116px;
    background: url('../../assets/img/products/service/serviceTitle.png') no-repeat;
    text-align: center;
  }
  .introductionContent{
    display: flex;
    flex-wrap: wrap;
    width: 1220px;
    margin: 0 auto;
    div{
      width: 406px;
      height: 222px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 40px;
      box-sizing: border-box;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 23px;
      letter-spacing: 1px;
      color: #000000;
    }
  }
  .introductionTable{
    width: 982px;
    margin: 136px auto 95px;
    thead{
      td{
        height: 36px;
        background: #e3efff;
        font-size: 15px;
        text-align: center;
        letter-spacing: 1px;
      }
    }
    tbody{
      td{
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        background: #f3f3f3;
        box-sizing: border-box;
      }
      td:nth-child(1){
        width: 105px;
        padding: 0;
        text-align: center;
      }
      td:nth-child(2){
        width: 366px;
        padding: 30px 35px;
      }
      td:nth-child(3){
        width: 504px;
        padding: 11px 18px;
      }
    }
  }
}
.case{
  .title{
    width: 512px;
    height: 67px;
    background: url("../../assets/img/products/service/caseTitle.png") no-repeat;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;
    margin: 0 auto 76px;
    text-align: center;
    line-height: 30px;
  }
  .content{
    width: 100%;
    background: #e3efff;
    text-align: center;
    padding: 17px 0 69px;
    .contentTitle{
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
    }
    .text{
      width: 960px;
      margin: 7px auto 26px;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 1px;
      text-align: left;
      text-indent:2em;
    }
  }
}
.range{
  width: 956px;
  margin: 111px auto 0;
  .title{
    width: 127px;
    height: 27px;
    background-color: #006efd;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 27px;
    letter-spacing: 2px;
    color: #ffffff;
    text-align: center;
  }
  .rangeContent{
    width: 915px;
    margin: 30px 0 94px 23px;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .training{
    margin-top: 88px;
    display: flex;
    .trainingContent{
      width: 304px;
      height: 95px;
      border-left: 5px solid #006efd;
      padding-left: 106px;
      box-sizing: border-box;
      padding-top: 22px;
      margin-bottom: 8px;
      div:nth-child(1){
        width: 193px;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 20px;
        letter-spacing: 27px;
        color: #006efd;
        border: 1px solid #006efd;
        box-sizing: border-box;
        padding-left: 30px;
      }
      div:nth-child(2){
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #006efd;
        text-align: center;
        margin-top: 15px;
      }
    }
    .trainingContent:nth-child(2){
      border-color: #ed1c24;
    }
    &>div:nth-child(2){
      margin-left: 142px;
    }

  }
}
.trainingList{
  width: 100%;
  height: 687px;
  background: url("../../assets/img/products/service/trainingListBg.png") no-repeat;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  padding: 115px 278px;
  justify-content: space-between;
  .trainingListContent{
    width: 25.1%;
    .img{
      width: 115px;
      height: 115px;
      background:rgba(0,160,233,0.08);
      border: solid 1px rgba(0,0,0,0.08);
      border-radius: 50%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      margin:  0 auto;
    }
    .content{
      margin-top: 15px;
      display: flex;
      justify-content: center;
      span{
        display: inline-block;
      }
      span:nth-child(1){
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #ffffff;
        height: 37px;
        line-height: 37px;
      }
      span:nth-child(2){
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #ffffff;
        border-left: 1px solid #fff;
        height: 37px;
        line-height: 37px;
        margin-left: 15px;
        padding-left: 13px;
      }
    }
  }
  .trainingListContent:nth-child(n+4){
    margin-top: 90px;
  }
}
.service{
  text-align: center;
  .title{
    width: 502px;
    height: 67px;
    line-height: 30px;
    text-align: center;
    margin: 55px auto 65px;
    background: url("../../assets/img/products/service/approvalTitle.png") no-repeat;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;

  }
  img{
    margin-bottom: 64px;
  }
  .text{
    width: 1030px;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    margin: 0 auto;
    text-indent: 2em;
    text-align: left;
  }
}
.approval{
  width: 100%;
  height: 687px;
  background: url("../../assets/img/products/service/approvalBg.png");
  margin-top: 75px;
  &>div{
    width: 1000px;
    margin: 0 auto;
    padding-top: 80px;
    .title{
      width: 127px;
      height: 27px;
      background-color: #006efd;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 27px;
      letter-spacing: 2px;
      color: #ffffff;
      margin-bottom: 90px;
      text-align: center;
    }
    .list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .content{
        display: flex;
        padding-left: 45px;
        margin-bottom: 97px;
        .left{
          width: 118px;
          height: 130px;
          background-color: #ffffff;
          border-radius: 10px;
          .ellipse{
            margin-left: 32.5px;
            margin-top: -22.5px;
            width:45px;
            height:45px;
            background: #006efd;
            border-radius: 100px;
            text-align: center;
            color: #fff;
            font-size: 10px;
            padding-top: 6px;
            box-sizing: border-box;
            &:after{
              content: '';
              display:inline-block;
              width:47px;
              height: 32.5px;
              position:relative;
              opacity: 0.25;
              background: #006efd;
              top:-40%;
              left:-1px;
              border-bottom-left-radius: 50px;
              border-bottom-right-radius: 50px;
            }
          }
          .text{
            text-align: center;
            margin-top: 30px;
            font-size: 15px;
            line-height: 25px;
          }
        }
        .right{
          width: 76px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          i{
            color: #fff;
            font-size: 30px;
          }
        }
      }
    }
  }

}
.third{
  text-align: center;
  margin-top: 80px;
  .title{
    width: 360px;
    height: 67px;
    line-height: 30px;
    background: url("../../assets/img/products/service/thirdTitle.png") no-repeat;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;
    margin: 0 auto;
    text-align: center;
  }
  &>img{
    margin: 65px 0;
  }
  .text{
    width: 1030px;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    text-indent: 2em;
    margin: 0 auto;
    text-align: left;
  }
  .service{
    width: 1030px;
    margin: 78px auto;
    .thirdTitle{
      width: 127px;
      height: 27px;
      background-color: #006efd;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 27px;
      letter-spacing: 2px;
      color: #ffffff;
      text-align: center;
    }
    .list{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 78px;
      &>div{
        width: 276px;
        height: 250px;
        margin-bottom: 20px;
        padding-top: 53px;
        box-sizing: border-box;
        &>div:nth-child(1){
          width: 80px;
          height: 80px;
          border-radius: 80px;
          border: 1px solid #fff;
          margin:  0 auto 34px;
          text-align: center;
          padding-top: 15px;
          box-sizing: border-box;
          img{
            width: 50px;
          }
        }
        &>div:nth-child(2){
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 27px;
          letter-spacing: -1px;
          color: #ffffff;
        }
      }
      &>div:nth-child(n){
        background-color: #006efd
      }
      &>div:nth-child(2n){
        background-color: #c1dcff;
      }
      &>div:nth-child(1){
        &>div:nth-child(1){
          padding-top: 25px;
        }
      }
      &>div:nth-child(3){
        &>div:nth-child(1){
          padding-top: 16px;
          img{
            margin-left: 5px;
          }
        }
      }
      &>div:nth-child(6){
        &>div:nth-child(1){
          padding-top: 12px;
          img{
            margin-left: -5px;
          }
        }
      }
    }
  }

}
</style>